import { doc, getDoc } from "firebase/firestore";
import {
  NUCLEUS_PORTAL_COLLECTION,
  NUCLEUS_SHOW_PHONE_LOGIN,
} from "../config/constants";
import { db } from "../config/firebaseConfig";

export const fetchShowPhoneLoginToggle = async (
  setShowPhoneLogin: Function
) => {
  const docRef = doc(db, NUCLEUS_PORTAL_COLLECTION, NUCLEUS_SHOW_PHONE_LOGIN);
  const docSnap = await getDoc(docRef);
  if (docSnap.exists()) {
    setShowPhoneLogin(docSnap.data().showPhoneLogin);
  } else {
    console.warn("No such document!");
    setShowPhoneLogin(false);
  }
};
